<template>
  <div class="flex-column flex-justify-start flex-align-center">
    <div class="video-container mt20">
      <video
        id="video-player"
        ref="videoPlayer"
        class="video-js vjs-default-skin vjs-big-play-centered"
        controls
        preload="auto"
        width="720"
        height="480"
        autoplay
      ></video>
    </div>
    <p class="fz24">라이브 스트리밍 소스 선택</p>

    <div class="flex-row flex-justify-center flex-align-center mt10">
      <template v-if="liveState && isDockLive">
        <span class="mr10">렌즈:</span>
        <a-radio-group v-model:value="lensSelected" button-style="solid">
          <a-radio-button v-for="lens in lensList" :key="lens" :value="lens">{{
            lens
          }}</a-radio-button>
        </a-radio-group>
      </template>
      <template v-else>
        <a-select
          style="width: 150px"
          placeholder="라이브 유형 선택"
          @select="onLiveTypeSelect"
          v-model:value="livetypeSelected"
        >
          <a-select-option
            v-for="item in liveTypeList"
            :key="item.label"
            :value="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <a-select
          class="ml10"
          style="width: 150px"
          placeholder="드론 선택"
          v-model:value="droneSelected"
        >
          <a-select-option
            v-for="item in droneList"
            :key="item.value"
            :value="item.value"
            @click="onDroneSelect(item)"
            >{{ item.label }}</a-select-option
          >
        </a-select>
        <a-select
          class="ml10"
          style="width: 150px"
          placeholder="카메라 선택"
          v-model:value="cameraSelected"
        >
          <a-select-option
            v-for="item in cameraList"
            :key="item.value"
            :value="item.value"
            @click="onCameraSelect(item)"
            >{{ item.label }}</a-select-option
          >
        </a-select>
        <!-- <a-select
        class="ml10"
        style="width:150px"
        placeholder="Select Lens"
        v-model:value="videoSelected"
      >
        <a-select-option
          v-for="item in videoList"
          :key="item.value"
          :value="item.value"
          @click="onVideoSelect(item)"
          >{{ item.label }}</a-select-option
        >
      </a-select> -->
      </template>
      <a-select
        class="ml10"
        style="width: 150px"
        placeholder="화질 선택"
        @select="onClaritySelect"
        v-model:value="claritySelected"
      >
        <a-select-option
          v-for="item in clarityList"
          :key="item.value"
          :value="item.value"
          >{{ item.label }}</a-select-option
        >
      </a-select>
    </div>
    <div class="mt20">
      <p class="fz10" v-if="livetypeSelected == 2">
        RTSP 라이브 스트리밍을 재생하려면 VLC 미디어 플레이어를 사용하십시오 !!!
      </p>
      <p class="fz10" v-if="livetypeSelected == 2">
        RTSP 파라미터:{{ rtspData }}
      </p>
    </div>
    <div class="mt10 flex-row flex-justify-center flex-align-center">
      <a-button
        v-if="liveState && isDockLive"
        type="primary"
        large
        @click="onSwitch"
        >렌즈 전환</a-button
      >
      <a-button v-else type="primary" large @click="onStart">재생</a-button>
      <a-button class="ml20" type="primary" large @click="onStop"
        >중지</a-button
      >
      <a-button class="ml20" type="primary" large @click="onUpdateQuality"
        >화질 업데이트</a-button
      >
      <a-button
        v-if="!liveState || !isDockLive"
        class="ml20"
        type="primary"
        large
        @click="onRefresh"
        >라이브 역량 새로고침</a-button
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import { message } from 'ant-design-vue'
import { onMounted, onBeforeUnmount, reactive, ref } from 'vue'
import { CURRENT_CONFIG as config } from '/@/api/http/config'
import {
  changeLivestreamLens,
  getLiveCapacity,
  setLivestreamQuality,
  startLivestream,
  stopLivestream,
} from '/@/api/manage'
import { getRoot } from '/@/root'
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import srs from '/@/vendors/srs.sdk.js'

const root = getRoot()

interface SelectOption {
  value: any
  label: string
  more?: any
}

const liveTypeList: SelectOption[] = [
  {
    value: 1,
    label: 'RTMP',
  },
  {
    value: 2,
    label: 'RTSP',
  },
  {
    value: 3,
    label: 'GB28181',
  },
  {
    value: 4,
    label: 'WEBRTC',
  },
]
const clarityList: SelectOption[] = [
  {
    value: 0,
    label: '자동',
  },
  {
    value: 1,
    label: '원활',
  },
  {
    value: 2,
    label: '일반',
  },
  {
    value: 3,
    label: 'HD',
  },
  {
    value: 4,
    label: '초고화질',
  },
]

const videoPlayer = ref(null)
const player = ref<any>(null)
const livestreamSource = ref()
const droneList = ref()
const cameraList = ref()
const videoList = ref()
const droneSelected = ref()
const cameraSelected = ref()
const videoSelected = ref()
const claritySelected = ref()
const videoId = ref()
const liveState = ref<boolean>(false)
const livetypeSelected = ref()
const rtspData = ref()
const lensList = ref<string[]>([])
const lensSelected = ref<String>()
const isDockLive = ref(false)
const nonSwitchable = 'normal'
let webrtc: any = null

const onRefresh = async () => {
  droneList.value = []
  cameraList.value = []
  videoList.value = []
  droneSelected.value = null
  cameraSelected.value = null
  videoSelected.value = null
  await getLiveCapacity({})
    .then((res) => {
      console.log(res)
      if (res.code === 0) {
        if (res.data === null) {
          console.warn('경고: 라이브 역량을 가져오지 못했습니다!!!')
          return
        }
        const resData: Array<[]> = res.data
        console.log('live_capacity:', resData)
        livestreamSource.value = resData

        const temp: Array<SelectOption> = []
        if (livestreamSource.value) {
          livestreamSource.value.forEach((ele: any) => {
            temp.push({
              label: `${ele.device_name}-${ele.device_sn} ${ele.status ? '(온라인)' : '(오프라인)'}`,
              value: ele.device_sn,
              more: ele.cameras_list,
            })
          })
          droneList.value = temp
        }
      }
    })
    .catch((error) => {
      message.error(error)
      console.error(error)
    })
}

onMounted(() => {
  onRefresh()
  if (videoPlayer.value) {
    player.value = videojs(videoPlayer.value, {
      autoplay: true,
      controls: true,
      responsive: true,
      fluid: false,
    })
  }
})

onBeforeUnmount(() => {
  if (player.value) {
    player.value.dispose()
  }
})
const onStart = async () => {
  console.log(
    'Param:',
    livetypeSelected.value,
    droneSelected.value,
    cameraSelected.value,
    videoSelected.value,
    claritySelected.value,
  )
  const timestamp = new Date().getTime().toString()
  if (
    livetypeSelected.value == null ||
    droneSelected.value == null ||
    cameraSelected.value == null ||
    claritySelected.value == null
  ) {
    message.warn('경고: 라이브 파라미터를 선택하지 않았습니다!!!')
    return
  }
  videoId.value =
    droneSelected.value +
    '/' +
    cameraSelected.value +
    '/' +
    (videoSelected.value || nonSwitchable + '-0')

  let liveURL = ''
  switch (livetypeSelected.value) {
    case 1: {
      // RTMP
      liveURL = config.rtmpURL + timestamp
      break
    }
    case 2: {
      // RTSP
      liveURL = `userName=${config.rtspUserName}&password=${config.rtspPassword}&port=${config.rtspPort}`
      break
    }
    case 3: {
      liveURL = `serverIP=${config.gbServerIp}&serverPort=${config.gbServerPort}&serverID=${config.gbServerId}&agentID=${config.gbAgentId}&agentPassword=${config.gbPassword}&localPort=${config.gbAgentPort}&channel=${config.gbAgentChannel}`
      break
    }
    case 4: {
      break
    }
    default:
      console.warn('warning: live type is not correct!!!')
      break
  }
  await startLivestream({
    url: liveURL,
    video_id: videoId.value,
    url_type: livetypeSelected.value,
    video_quality: claritySelected.value,
  })
    .then((res) => {
      if (res.code !== 0) {
        return
      }
      if (livetypeSelected.value === 3 || livetypeSelected.value === 1) {
        const url = res.data.url
        console.log('start live:', url)
        if (player.value) {
          player.value.src({
            src: url,
            type: url.includes('.m3u8') ? 'application/x-mpegURL' : (url.includes('.flv') ? 'video/x-flv' : 'video/mp4'),
          })
          player.value.load()
          player.value.play()
        }
      } else if (livetypeSelected.value === 2) {
        console.log(res)
        rtspData.value = 'url:' + res.data.url
      } else if (livetypeSelected.value === 4) {
        const videoElement = videoPlayer.value as unknown as HTMLMediaElement
        videoElement.muted = true
        playWebrtc(videoElement, res.data.url)
      }
      liveState.value = true
    })
    .catch((err) => {
      console.error(err)
    })
}
const onStop = () => {
  videoId.value =
    droneSelected.value +
    '/' +
    cameraSelected.value +
    '/' +
    (videoSelected.value || nonSwitchable + '-0')

  stopLivestream({
    video_id: videoId.value,
  }).then((res) => {
    if (res.code === 0) {
      message.success(res.message)
      liveState.value = false
      lensSelected.value = undefined
      console.log('stop play livestream')
    }
  })
}

const onUpdateQuality = () => {
  if (!liveState.value) {
    message.info('먼저 라이브 스트리밍을 시작해 주세요.')
    return
  }
  setLivestreamQuality({
    video_id: videoId.value,
    video_quality: claritySelected.value,
  }).then((res) => {
    if (res.code === 0) {
      message.success(
        '화질이 ' +
          clarityList[claritySelected.value].label +
          '(으)로 설정되었습니다.',
      )
    }
  })
}

const onLiveTypeSelect = (val: any) => {
  livetypeSelected.value = val
}
const onDroneSelect = (val: SelectOption) => {
  droneSelected.value = val.value
  const temp: Array<SelectOption> = []
  cameraList.value = []
  cameraSelected.value = undefined
  videoSelected.value = undefined
  videoList.value = []
  lensList.value = []
  if (!val.more) {
    return
  }
  val.more.forEach((ele: any) => {
    temp.push({ label: ele.name, value: ele.index, more: ele.videos_list })
  })
  cameraList.value = temp
}
const onCameraSelect = (val: SelectOption) => {
  cameraSelected.value = val.value
  const result: Array<SelectOption> = []
  videoSelected.value = undefined
  videoList.value = []
  lensList.value = []
  if (!val.more) {
    return
  }

  val.more.forEach((ele: any) => {
    result.push({
      label: ele.type,
      value: ele.index,
      more: ele.switch_video_types,
    })
  })
  videoList.value = result
  if (videoList.value.length === 0) {
    return
  }
  const firstVideo: SelectOption = videoList.value[0]
  videoSelected.value = firstVideo.value
  lensList.value = firstVideo.more
  lensSelected.value = firstVideo.label
  isDockLive.value = lensList.value?.length > 0
}
const onVideoSelect = (val: SelectOption) => {
  videoSelected.value = val.value
  lensList.value = val.more
  lensSelected.value = val.label
}
const onClaritySelect = (val: any) => {
  claritySelected.value = val
}
const onSwitch = () => {
  if (
    lensSelected.value === undefined ||
    lensSelected.value === nonSwitchable
  ) {
    message.info(
      nonSwitchable +
        ' 렌즈는 전환할 수 없습니다. 전환할 렌즈를 선택해 주세요.',
      8,
    )
    return
  }
  changeLivestreamLens({
    video_id: videoId.value,
    video_type: lensSelected.value,
  }).then((res) => {
    if (res.code === 0) {
      message.success('라이브 카메라가 성공적으로 전환되었습니다.')
    }
  })
}
const playWebrtc = (videoElement: HTMLMediaElement, url: string) => {
  if (webrtc) {
    webrtc.close()
  }
  webrtc = new srs.SrsRtcWhipWhepAsync()
  videoElement.srcObject = webrtc.stream
  webrtc
    .play(url)
    .then(function (session: any) {
      console.info(session)
    })
    .catch(function (reason: any) {
      webrtc.close()
      console.error(reason)
    })
}
</script>

<style lang="scss" scoped>
@import "/@/styles/index.scss";
</style>
